import { injectable } from "inversify";
import {
  HttpCoordinateInfo,
  ICoordinateInfoParser,
} from "../addressRepository.types";
import { CoordinateInfo, ICoordinateInfo } from "@/domain/entities/address";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { Result, ok } from "neverthrow";

@injectable()
export class CoordinateInfoParser implements ICoordinateInfoParser {
  toDomain(data: HttpCoordinateInfo): Result<ICoordinateInfo, ParseError> {
    try {
      const coordinateInfoData: ICoordinateInfo = {
        latitude: data.latitude,
        longitude: data.longitude,
      };
      const coordinateInfo = new CoordinateInfo(coordinateInfoData);
      return ok(coordinateInfo);
    } catch (error: any) {
      return error(new ParseError(error.message));
    }
  }
}
